import React from 'react'

const BuyPage = () => (
  <section className="main wrapper style2">
    <header className="major">
      <h2>Purchase Strategeist</h2>
    </header>
    <div className="container">
    <section>
        <header>
          <h3>System Requirements</h3>
        </header>
        <div className="row">
          <div className="col-6 col-6-narrow col-12-mobile">
            <ul>
              <li>
                <strong>Processor:</strong> 2 GHz
              </li>
              <li>
                <strong>OS:</strong> Windows 7/8/10 64-bit{' '}
              </li>
              <li>
                <strong>RAM:</strong> 8 GB
              </li>
              <li>
                <strong>Video Card:</strong> 1 GB
              </li>
              <li>
                <strong>Hard Disk Space:</strong> 2 GB{' '}
              </li>
            </ul>
          </div>
        </div>
      </section>


      <section>
        <p>
          Strategeist is currently in closed beta. You will be asked to sign a
          non-disclosure agreement before being granted access. If you would
            like to join, please fill out the form below.
        </p>
        <form
          name="beta-form"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          method="post"
        >
          <div className="row gtr-uniform gtr-50">
            <div className="col-12">
              <input type="text" name="name" placeholder="Name" />
            </div>
            <div className="col-12">
              <input type="email" name="email" placeholder="Email" />
            </div>
            <div className="col-12">
              Any experience with strategy games?
              <textarea name="experience" />
            </div>
            <div className="col-12">
              Why would you like to join the beta?
              <textarea name="why" />
            </div>
            <div className="col-12">
              <ul className="actions">
                <li>
                  <input type="submit" value="Sign up" className="primary" />
                </li>
              </ul>
            </div>
          </div>
        </form>
      </section>
    </div>
  </section>
)

export default BuyPage



// WEBPACK FOOTER //
// ./src/pages/buy.js